const { signal } = require("@preact/signals");

export const dealerSignal = signal(null);